
















































































































































import { Component, Vue, Prop } from 'vue-property-decorator'

import ElsaFormGroup from '@/components/form-group/form-group.vue'
import ElsaProgressBar from '@/components/progress-bar/progress-bar.vue'
import { Opintosuoritus, OpintosuoritusOsakokonaisuus } from '@/types'

@Component({
  components: {
    ElsaFormGroup,
    ElsaProgressBar
  }
})
export default class OpintosuoritusTab extends Vue {
  @Prop({ required: true, type: Array })
  suoritukset!: Opintosuoritus[]

  @Prop({ required: true, type: String })
  variant!: string

  @Prop({ required: false, type: Number })
  suoritettu!: number

  @Prop({ required: false, type: Number })
  vaadittu!: number

  @Prop({ required: false, type: Boolean, default: false })
  progress!: boolean

  localizeName(o: Opintosuoritus | OpintosuoritusOsakokonaisuus): string {
    const name = this.$i18n.locale === 'sv' ? o.nimi_sv : o.nimi_fi
    return name?.trim() ? name : o.nimi_fi || ''
  }

  examSubparts(o: Opintosuoritus): OpintosuoritusOsakokonaisuus[] {
    if (this.variant !== 'kuulustelu') return []
    const compare = (a: string, b: string) => (a < b ? -1 : a > b ? 1 : 0)
    return [...(o.osakokonaisuudet || [])].sort(
      (a, b) =>
        compare(a.suorituspaiva || '', b.suorituspaiva || '') ||
        compare(this.localizeName(a), this.localizeName(b)) ||
        compare(a.kurssikoodi || '', b.kurssikoodi || '') ||
        (a.id || 0) - (b.id || 0)
    )
  }
}
